import { getUserDetails } from 'util/api'
import { getCache, setCache, verifyLogin } from 'util/cache'
import { useDocTitle } from 'util/hooks'

import books from 'img/dashicons-book.svg'
import editPage from 'img/dashicons-edit-page.svg'
import groups from 'img/dashicons-groups.svg'
import React, { useState, useEffect, useCallback } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import 'css/pages/dashboard.scss'

export const Dashboard = () => {
	const navigate = useNavigate()

	const [name, setName] = useState(getCache('firstName'))
	const [ready, setReady] = useState(false)
	const [loadFailed, setLoadFailed] = useState(false)

	const initializeUserDetails = useCallback(async () => {
		const verified = verifyLogin(navigate)

		if (!verified) return

		// err-8: a failed details fetch used to leave an infinite "Loading..."
		// plus an unhandled rejection
		let userDetails
		try {
			userDetails = await getUserDetails()
		} catch (e) {
			setLoadFailed(true)
			return
		}

		if (userDetails?.accountType === 'student') {
			navigate('/enter-code', { replace: true })
			return
		}

		setCache(userDetails)
		setName(userDetails.firstName)
		setLoadFailed(false)
		setReady(true)
	}, [navigate])

	useDocTitle('All for One - Dashboard')

	useEffect(() => {
		verifyLogin(navigate)
		initializeUserDetails()
	}, [navigate, initializeUserDetails])

	if (loadFailed) {
		return (
			<div className="center-container">
				<h1 className="dashboard-header">We couldn't load your dashboard</h1>
				<p>Check your connection, then <a href="#retry" onClick={e => { e.preventDefault(); setLoadFailed(false); initializeUserDetails() }}>try again</a>.</p>
			</div>
		)
	}

	if (!ready) {
		return <div className="center-container"><h1 className="dashboard-header">Loading...</h1></div>
	}

	return (
		<div className="center-container">
			<h1 className="dashboard-header">Hey {name}!</h1>
			<section className="dashboard-container">
				<Link to="/classrooms">
					<div className="dashboard-card">
						<div className="card-row">
							<img src={groups} alt="My Classrooms" />
							<h2 className="card-title">My Classrooms</h2>
						</div>
						<p className="card-description">Manage your students</p>
					</div>
				</Link>
				<Link to="/upload-lessons">
					<div className="dashboard-card">
						<div className="card-row">
							<img src={editPage} alt="Plan New Lesson" />
							<h2 className="card-title">Plan New Lesson</h2>
						</div>
						<p className="card-description">Create new lesson</p>
					</div>
				</Link>
				<Link to="/lessons">
					<div className="dashboard-card">
						<div className="card-row">
							<img src={books} alt="My Lesson Library" />
							<h2 className="card-title">My Lesson Library</h2>
						</div>
						<p className="card-description">Access your saved lessons</p>
					</div>
				</Link>
			</section>
		</div>
	)
}